const cacheImages = (srcArray) => {
  const promises = srcArray.map(
    (url) =>
      new Promise((resolve, reject) => {
        const img = new Image()
        img.src = url
        img.onload = () => {
          resolve(url)
        }
        img.onerror = reject
      })
  )

  return Promise.all(promises)
}

const cacheVideos = (srcArray) => {
  const promises = srcArray.map(
    (vid) =>
      new Promise((resolve, reject) => {
        const videoRequest = fetch(vid.url).then((response) => response.blob())
        videoRequest
          .then((blob) => {
            const fileName = vid.filename
            const vidObj = {
              fileName,
              blob: window.URL.createObjectURL(blob),
            }
            resolve(vidObj)
          })
          .catch((error) => {
            reject(error)
          })
      })
  )

  return Promise.all(promises)
}

export { cacheImages, cacheVideos }
